import AxiosConfig from '../../../config/AxiosConfig';

const useRetractOrderSLO = () => {
  const retractOrderSLO = async (orderRef, retractionData) => {
    try {
      const response = await AxiosConfig.create(
        'post',
        `/orders/${orderRef}/retractOrderSLO`
      )
        .call(retractionData)
        .getResponseData();

      return response;
    } catch (err) {
      console.error('Failed to retract order SLO:', err);
      throw new Error(`SLO Order retraction failed: ${err.message}`);
    }
  };

  return {
    retractOrderSLO,
  };
};

export default useRetractOrderSLO;
